// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_text_pad/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_text_pad: ModuleSchema = {
  "id": "core_text_pad",
  "uniqueId": "B3D_TXPD1",
  "createdAt": "2026-10-15T00:00:00Z",
  "updatedAt": "2026-10-16T00:52:42.492Z",
  "label": "Continuous Text Pad",
  "description": "Reusable continuous rounded backing for text/detail contours (CG_TEXT_PAD01).",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_TEXT_PAD01",
    "text",
    "backing",
    "pad"
  ],
  "sliders": [
    {
      "key": "detailWidth",
      "label": "Detail Width (mm)",
      "min": 4,
      "max": 100,
      "default": 40,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "detailHeight",
      "label": "Detail Height (mm)",
      "min": 4,
      "max": 50,
      "default": 12,
      "step": 1,
      "unit": "mm"
    },
    {
      "key": "cornerRadius",
      "label": "Detail Corner Radius (mm)",
      "min": 0,
      "max": 25,
      "default": 2,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "offset",
      "label": "Pad Offset (mm)",
      "min": 0,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "closeRadius",
      "label": "Gap Closing Radius (mm)",
      "min": 0,
      "max": 15,
      "default": 3,
      "step": 0.5,
      "unit": "mm"
    },
    {
      "key": "baseDepth",
      "label": "Base Depth (mm)",
      "min": 0.1,
      "max": 30,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "detailDepth",
      "label": "Detail Depth (mm)",
      "min": 0.1,
      "max": 10,
      "default": 0.2,
      "step": 0.1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "base",
      "label": "Pad Base",
      "default": "#2563EB",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "detail",
      "label": "Detail",
      "default": "#FFFFFF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "text_pad_base",
      "label": "Continuous Text Pad Base",
      "name": "Continuous Text Pad Base",
      "color": "#2563EB",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": []
    },
    {
      "id": "text_pad_detail",
      "label": "Text Detail",
      "name": "Text Detail",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": []
    }
  ],
  "exportGroups": []
};
